import React from 'react';
import { useTranslation } from 'react-i18next';
const SocialShare = ({ onShareClick }) => {
    const { t } = useTranslation();
    const toggleShare = (type) => {
        onShareClick(type);
    };
    const renderButton = ({ icon, type, onClick }) => {
        return (React.createElement("button", { onClick: () => onClick(type), role: "button", className: "w-14 h-14 text-xl rounded-full bg-blue-600 inline-flex items-center justify-center text-white" }, icon));
    };
    return (React.createElement("div", { className: "flex flex-col items-center md:sticky md:top-4 gap-4" },
        React.createElement("h5", { className: "text-lg text-gray-800 font-semibold leading-[150%]" }, t('learn.share')),
        React.createElement("div", { className: "flex md:flex-col flex-wrap justify-center items-center gap-2" },
            renderButton({
                icon: React.createElement("i", { className: "material-icons" }, "share"),
                type: 'share',
                onClick: (type) => toggleShare(type)
            }),
            renderButton({
                icon: React.createElement("i", { className: "fa-brands fa-x-twitter" }),
                type: 'twitter',
                onClick: (type) => toggleShare(type)
            }),
            renderButton({
                icon: React.createElement("i", { className: "fa-brands fa-linkedin-in" }),
                type: 'linkedin',
                onClick: (type) => toggleShare(type)
            }),
            renderButton({
                icon: React.createElement("i", { className: "fa-brands fa-facebook-f" }),
                type: 'facebook',
                onClick: (type) => toggleShare(type)
            }))));
};
export default SocialShare;
